// Photo field on the contact form (sections/tilerie-contact.liquid): each photo is downsized in the
// browser to a JPEG of at most 2000 px (which also drops EXIF/GPS), sent to the uploads worker and
// its link added to a hidden field, so the links arrive in the Shopify contact message.
(() => {
  const MAX_SIDE = 2000;

  async function toJpeg(file) {
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    return new Promise((resolve, reject) =>
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('encode'))), 'image/jpeg', 0.85)
    );
  }

  document.querySelectorAll('[data-photo-upload]').forEach((root) => {
    const endpoint = root.dataset.photoUpload;
    const max = Number(root.dataset.max) || 3;
    const input = root.querySelector('input[type="file"]');
    const hidden = root.querySelector('input[type="hidden"]');
    const list = root.querySelector('.tg-contact__thumbs');
    const status = root.querySelector('.tg-contact__upload-status');
    const drop = root.querySelector('.tg-contact__drop');
    const form = root.closest('form');
    const items = []; // { li, url, busy }

    const sync = () => {
      hidden.value = items.filter((i) => i.url).map((i) => i.url).join('\n');
      drop.hidden = items.length >= max;
    };

    const add = async (file) => {
      const li = document.createElement('li');
      li.className = 'tg-contact__thumb is-busy';
      const img = document.createElement('img');
      img.alt = '';
      const preview = URL.createObjectURL(file);
      img.src = preview;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'tg-contact__thumb-remove';
      remove.setAttribute('aria-label', `${root.dataset.msgRemove} ${file.name}`);
      remove.textContent = '×';
      li.append(img, remove);
      list.append(li);
      const item = { li, url: '', busy: true };
      items.push(item);
      remove.addEventListener('click', () => {
        items.splice(items.indexOf(item), 1);
        li.remove();
        URL.revokeObjectURL(preview);
        sync();
      });
      sync();
      try {
        const blob = await toJpeg(file);
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'image/jpeg' }, body: blob });
        if (!response.ok) throw new Error(String(response.status));
        item.url = (await response.json()).url;
        li.classList.remove('is-busy');
      } catch (error) {
        items.splice(items.indexOf(item), 1);
        li.remove();
        URL.revokeObjectURL(preview);
        status.textContent = root.dataset.msgError;
      }
      item.busy = false;
      sync();
    };

    input.addEventListener('change', () => {
      status.textContent = '';
      Array.from(input.files)
        .slice(0, max - items.length)
        .forEach(add);
      input.value = '';
    });

    form.addEventListener('submit', (event) => {
      if (items.some((i) => i.busy)) {
        event.preventDefault();
        status.textContent = root.dataset.msgBusy;
      }
    });
  });
})();
